import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import $ from 'jquery';
import Ajax from '../ajax/Ajax';

class Rumors extends Component {
	
	constructor(props) {
		super(props);
		this.state = {rumors: {}, sorted: false};
		this.addRumor = this.addRumor.bind(this);
		this.updateRumor = this.updateRumor.bind(this);
		this.update = this.update.bind(this);
		this.sortRumors = this.sortRumors.bind(this);
	}
	
	componentWillMount() {
		var obj = this;
		Ajax.getRumors().then(function(rumors) {			
			obj.setState({rumors: rumors});
			obj.sortRumors(rumors, "touch");
		});
	}
	
	sortRumors(rumors, field) {
		var obj = this;
		var list = rumors;
		var keysSorted = Object.keys(list).sort(
			function(a, b) {
				return (list[a][field] > list[b][field] ? -1 : 1);
			}
		);
		obj.setState({sorted: keysSorted});
	}
	
	update(rumors) {
		var obj = this;
		Ajax.postRumors(rumors).then(function () {			
			obj.setState({rumors: rumors});
		});		
	}
	
	addRumor(event) {
		var obj = this;
		Ajax.getRumors().then(function (rumors) {
			var id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
			var rumor = { content: "&nbsp;", touch: new Date().getTime() };
			rumors[id] = rumor;			
			obj.setState({rumors: rumors});
			obj.sortRumors(rumors, "touch");
			obj.update(rumors);
		});		
	}
	
	updateRumor(id) {
		var obj = this;
		
		return function(event) {
			Ajax.getRumors().then(function (rumors) {
				var el = $("#" + id);
				var content = $(".RumorContent", el).first()[0].innerHTML;				
				var rumor = { content: content, touch: new Date().getMilliseconds() };				
				rumors[id] = rumor;
				obj.setState({rumors: rumors});
				obj.update(rumors);
			});
		};
	}
	
	render() {
		var rumors = this.state.rumors;
		var sorted = this.state.sorted;
		var obj = this;
		
		return (
		<div className="Rumors">			
			
			<div className="RumorList">				
				<div className="AddRumorSymbol" onClick={this.addRumor}>Ajouter une rumeur...</div>
				
				{rumors && sorted ? 				
				sorted.map(function(key, idx) {					
					var rumor = rumors[key];
					return (
					<div id={key} key={idx} className="Rumor">
						<div className="RumorContent" contentEditable="true" onBlur={obj.updateRumor(key)} dangerouslySetInnerHTML={{__html: rumor.content}}></div>
					</div>
					)
				}): null
				}
				
			</div>        
		</div>
		);
	}
}

export default Rumors;



// WEBPACK FOOTER //
// ./src/components/Rumors.js